import type { FieldPath, FieldValues, UseFormSetError } from 'react-hook-form'

import { ApiError } from '@/lib/api/client'
import { resolveApiErrorMessage } from '@/lib/api-error-messages'

/** Lỗi theo ô của màn Bán lẻ: key = tên ô server trả trong params.field. */
export type FieldErrors = Record<string, string>

/**
 * Đổi lỗi server (SHOP_*) thành lỗi theo ô. Lỗi không gắn ô nào nằm ở key
 * `form` để màn hiện ngay trên nút Lưu.
 */
export function shopFieldErrors(err: unknown, fallback: string): FieldErrors {
    if (err instanceof ApiError) {
        const text = resolveApiErrorMessage(err.code, err.params) ?? fallback
        const field = err.params?.field
        return { [typeof field === 'string' && field ? field : 'form']: text }
    }
    return { form: fallback }
}

/**
 * Đặt lỗi server lên form react-hook-form: lỗi có ô → `setError(<ô>)` (hiện
 * dưới ô qua ui/field), lỗi chung → `root.server`.
 */
export function setShopServerErrors<T extends FieldValues>(
    setError: UseFormSetError<T>,
    err: unknown,
    fallback: string,
) {
    for (const [field, message] of Object.entries(
        shopFieldErrors(err, fallback),
    )) {
        setError(field === 'form' ? 'root.server' : (field as FieldPath<T>), {
            type: 'server',
            message,
        })
    }
}
